import React from "react";
import CustomModal from "./CustomModal";

const ActionConfirmation = ({
  confTitle,
  openConf,
  children,
  isLoading,
  confirmationCtaText,
  onClose,
  handleConfirmation,
}) => {
  return (
    <CustomModal
      isConfirmation
      open={openConf}
      title={confTitle}
      isLoading={isLoading}
      handleConfirmationBtnText={confirmationCtaText}
      onClose={onClose}
      handleConfirmation={handleConfirmation}
    >
      {children}
    </CustomModal>
  );
};

export default ActionConfirmation;
